<template>
  <div>
    <Button size="small" @click="handleImportBtnClick" :loading="loading">导入</Button>
    <input ref="uploadInput" type="file" :accept="accept" style="display: none" @change="handleFileChange">
  </div>
</template>

<script>
  import XLSX from 'xlsx'
  export default {
    name: 'xlsx-importer',
    data () {
      return {
        loading: false
      }
    },
    props: {
      accept: {
        type: String,
        default: '.xlsx, .xls'
      },
      heatRate: Number
    },
    methods: {
      handleImportBtnClick () {
        if (!this.heatRate) {
          this.$Message.warning('请先填写相应的升温速率');
          return;
        }

        this.$refs.uploadInput.value = null;
        this.$refs.uploadInput.click();
      },
      handleFileChange ( e ) {
        let files = e.target.files;
        if (!files || files.length === 0) return;

        let rawFile = files[ 0 ];
        this.loading = true;
        this.fileConvertToWorkbook(rawFile).then(( workbook ) => {
          this.loading = false;
          let opts = { header: [ 'time', 'temperature', 'weight', 'dWeight' ] };

          let xlsxArr = XLSX.utils.sheet_to_json(workbook.Sheets[ workbook.SheetNames[ 0 ] ], opts);
          this.dispatchData(this.parseXLSXData(xlsxArr))
        }).catch(( err ) => {
          this.loading = false;
          this.$Message.error('导出使用数据出错， 请检查错误信息');
          window.console.error(err)
        })
      },
      fileConvertToWorkbook ( file ) {
        let reader = new FileReader();

        return new Promise(( resolve, reject ) => {
          try {
            reader.onload = ( e ) => {
              let data = e.target.result;
              resolve(XLSX.read(data, { type: 'binary' }))
            };

            reader.onerror = ( error ) => {
              reject(error)
            };

            reader.readAsBinaryString(file)
          } catch (error) {
            reject(error)
          }
        })
      },
      parseXLSXData ( xlsxArr ) {
        let tableArr = [];
        let length = 0, maxLength = 0, maxLengthIndex = 0;

        xlsxArr.forEach(( item, index ) => {
          length = Object.keys(item).length;
          if (maxLength < length) {
            maxLength = length;
            maxLengthIndex = index
          }
        });

        let tableHeader = Object.keys(xlsxArr[ maxLengthIndex ]);
        let rowData = {};
        xlsxArr.forEach(( item ) => {
          rowData = {};
          for (let i = 0; i < maxLength; i++) {
            rowData[ tableHeader[ i ] ] = item[ tableHeader[ i ] ] || ''
          }
          tableArr.push(rowData)
        });

        return { header: tableHeader, data: tableArr }
      },
      dispatchData ( { header, data } ) {
        let excelData = {heatRate: this.heatRate, header: header, body: data};
        this.$emit('on-select-file', excelData)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// xlsx-importer.vue?752c9668